import { deleteLobTypes } from "../../../../../actions/Utilities/LobType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteLobType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteLobTypes(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetLobTypes"]);
      toast.fire(
        "Success",
        "LOB Type has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Lob Type",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteLobType;
